import { connect } from 'react-redux'

import ConsumptionBypassModal from '@components/common/modal/ConsumptionBypassModal'

import services from '@services'
import { ConsumptionBypassModalState } from '@reducers/ui/consumptionBypassModal'

const mapStateToProps = (state: {
  consumptionBypassModal: ConsumptionBypassModalState
}) => {
  const { show, title } = state.consumptionBypassModal

  return {
    show,
    title,
  }
}

const mapDispatchToProps = () => {
  const { close, confirm } = services.UIService.ConsumptionBypassModal

  return {
    close,
    confirm,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConsumptionBypassModal)
